import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["minValue", "maxValue", "minName", "maxName", "classes", "variant", "onChange", "InputProps", "label", "fullWidth", "editMode", "thousandSeparator", "prefix", "suffix", "displayModeGridProps"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import { Grid, withStyles } from "components/mui";
import * as React from "react";
import NumberInput from "../../../../../componentLibrary/Fields/NumberField/NumberInput";
import classnames from "classnames";
import FieldBase from "componentLibrary/Fields/FieldBase";
import NumberFormat from "react-number-format";

/*
 * Taken from https://material-ui.com/demos/selects/
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default withStyles(function (theme) {
  return {
    rangeInput: {
      width: "calc(50% - 16px)",
      display: "flex"
    },
    inputWithLabel: {
      marginTop: "16px"
    },
    hyphen: {
      display: "flex",
      width: 32,
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center"
    },
    formControl: {
      display: "flex"
    }
  };
})(NumberRangeField);
function NumberRangeField(_ref) {
  var minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    minName = _ref.minName,
    maxName = _ref.maxName,
    classes = _ref.classes,
    variant = _ref.variant,
    onChange = _ref.onChange,
    _ref$InputProps = _ref.InputProps,
    InputProps = _ref$InputProps === void 0 ? {} : _ref$InputProps,
    label = _ref.label,
    fullWidth = _ref.fullWidth,
    _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? true : _ref$editMode,
    _ref$thousandSeparato = _ref.thousandSeparator,
    thousandSeparator = _ref$thousandSeparato === void 0 ? true : _ref$thousandSeparato,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    _ref$displayModeGridP = _ref.displayModeGridProps,
    displayModeGridProps = _ref$displayModeGridP === void 0 ? {} : _ref$displayModeGridP,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!editMode) {
    return /*#__PURE__*/_jsxs(Grid, _objectSpread(_objectSpread({
      container: true
    }, displayModeGridProps), {}, {
      children: [/*#__PURE__*/_jsx(NumberFormat, {
        value: minValue,
        displayType: "text",
        thousandSeparator: thousandSeparator,
        prefix: " ".concat(prefix || "")
      }), /*#__PURE__*/_jsx("div", {
        className: classes.hyphen,
        children: "-"
      }), /*#__PURE__*/_jsx(NumberFormat, {
        value: maxValue,
        displayType: "text",
        thousandSeparator: thousandSeparator,
        suffix: " ".concat(suffix || "")
      })]
    }));
  }
  return /*#__PURE__*/_jsxs(Grid, {
    container: true,
    children: [/*#__PURE__*/_jsx(FieldBase, _objectSpread(_objectSpread({
      label: label
    }, props), {}, {
      className: classnames(props.className, classes.rangeInput),
      fullWidth: true,
      children: /*#__PURE__*/_jsx(NumberInput, _objectSpread({
        variant: variant,
        value: minValue,
        name: minName,
        className: classnames(_defineProperty({}, classes.inputWithLabel, !!label)),
        placeholder: "min",
        onChange: onChange,
        prefix: " ".concat(prefix || "")
      }, InputProps))
    })), /*#__PURE__*/_jsx("div", {
      className: classes.hyphen,
      children: "-"
    }), /*#__PURE__*/_jsx(FieldBase, _objectSpread(_objectSpread({}, props), {}, {
      className: classnames(props.className, classes.rangeInput),
      fullWidth: true,
      children: /*#__PURE__*/_jsx(NumberInput, _objectSpread({
        variant: variant,
        value: maxValue,
        name: maxName,
        className: classnames(_defineProperty({}, classes.inputWithLabel, !!label)),
        placeholder: "max",
        onChange: onChange,
        suffix: " ".concat(suffix || "")
      }, InputProps))
    }))]
  });
}